import { FunctionComponent, useEffect, useState } from "react";
import InputMask from "react-input-mask";
import { isCep } from "validator-brazil";
import { useCheckout } from "../../context/CheckoutContext";
import styles from "../../pages/CheckoutDelivery/CheckoutEndEntrega.module.css";
import ApiService from "../../service/ApiService";

const FormDeliveryComponent: FunctionComponent = ({
  handleSubmitForm,
  setErros,
  errors,
  disabled,
  setDisabled,
}: {
  handleSubmitForm: () => void;
  setErros: (value: {
    cepError: string,
    allFieldsError: string,
  }) => void;
  errors: {
    cepError: string,
    allFieldsError: string,
  };
  disabled: boolean;
  setDisabled: (value: boolean) => void;
}) => {
  const width = window.innerWidth;

  const apiService = new ApiService();
  const { setAddressData, address } = useCheckout();

  const handleCepValueChange = ({ target: { value } }) => {
    if (isCep(value) && value !== "") {
      setAddressData({ ...address, cep: value });
      apiService.getCep(value.replace(/\D/g, "")).then((res) => {
        if (res.erro) {
          if (value.replace(/\D/g, "") !== "") {
            setErros({
              ...errors,
              cepError: "Insira um CEP válido",
            });
          }
          else setErros({ ...errors, cepError: "" });
        } else {
          setAddressData({
            cep: value,
            logradouro: res.logradouro,
            cidade: res.localidade,
            complemento: '',
            numero: res.complemento ? res.complemento : '',
            bairro: res.bairro,
            estado: res.uf,
          });
        }
      });
      setErros({ ...errors, cepError: "" });
    } else {
      setAddressData({ ...address, cep: value });
      if (value.replace(/\D/g, "") !== "") {
        setErros({
          ...errors,
          cepError: "Insira um CEP válido",
        });
      }
      else setErros({ ...errors, cepError: "" });
    }
  };

  const handleOnChange = ({ target: { value, name } }) => {
    setAddressData({ ...address, [name]: value });
  };

  useEffect(() => {
    setDisabled(true);
    if (Object.values(errors).some((x) => x !== "")) setDisabled(true);
    else {
      setErros({ ...errors, allFieldsError: "" });
      setDisabled(false);
    }
    if (Object.entries(address).some((x) => {
      if (x[0] === "complemento") return false
      if (!x[1]) return true
      if (x[0] === "cep") {
        if (!isCep(x[1]?.replace(/\D/g, ""))) {
          return true
        }
        return false
      }
      if (x[1] === "") return true
      return false
    })) {
      setDisabled(true);
      setErros({ ...errors, allFieldsError: "Preencha todos os campos" });
    } else {
      setDisabled(false);
      if (errors.cepError !== "") setDisabled(true)
      else setErros({ ...errors, allFieldsError: "" });
    }
  }, [address]);

  useEffect(() => {
    if (Object.values(errors).some((x) => x !== "")) setDisabled(true)
  }, [errors])

  return (
    <>
      <form className={styles.dados}>
        <div className={styles.textFields2}>
          <div className={styles.pagamento}>
            <span>CEP</span>
            <span className={styles.span}>*</span>
          </div>
          <InputMask
            placeholder="00.000-000"
            mask="99.999-999"
            className={styles.content}
            value={address.cep}
            onChange={handleCepValueChange}
          ></InputMask>
        </div>
        <div className={styles.textFields2}>
          <div className={styles.pagamento}>
            <span>Logradouro</span>
            <span className={styles.span}>*</span>
          </div>
          <input
            type="text"
            name="logradouro"
            value={address.logradouro}
            onChange={handleOnChange}
            placeholder="Ex.: Rua dos Ventos"
            className={styles.content}
            ></input>
        </div>
        <div className={styles.numerocomplemento}>
          <div className={styles.textFields2}>
            <div className={styles.pagamento}>
              <span>Número</span>
              <span className={styles.span}>*</span>
            </div>
            <input
              onChange={handleOnChange}
              name="numero"
              type="text"
              value={address.numero}
              placeholder="000"
              className={styles.content}
            ></input>
          </div>
          <div className={styles.textFields2}>
            <div className={styles.pagamento}>
              <span>Complemento</span>
              {/* <span className={styles.span}>*</span> */}
            </div>
            <input
              onChange={handleOnChange}
              name="complemento"
              type="text"
              value={address.complemento}
              placeholder="Ex.: Apto 302"
              className={styles.content}
            ></input>
          </div>
        </div>
        <div className={styles.numerocomplemento}>
          <div className={styles.textFields2}>
            <div className={styles.pagamento}>
              <span>Bairro</span>
              <span className={styles.span}>*</span>
            </div>
            <input
              type="text"
              name="bairro"
              value={address.bairro}
              onChange={handleOnChange}
              placeholder="Ex.: Caiçaras"
              className={styles.content}
            ></input>
          </div>
          <div className={styles.textFields2}>
            <div className={styles.pagamento}>
              <span>Cidade</span>
              <span className={styles.span}>*</span>
            </div>
            <input
              type="text"
              readOnly
              value={address.cidade}
              placeholder="Ex.: São Paulo"
              className={styles.content}
            ></input>
          </div>
        </div>
          <div className={styles.textFields2}>
            <div className={styles.pagamento}>
              <span>Estado</span>
              <span className={styles.span}>*</span>
            </div>
            <input
              type="text"
              readOnly
              value={address.estado}
              placeholder="Ex.: São Paulo"
              className={styles.content}
            ></input>
          </div>
        {Object.values(errors).map((x) =>
          x !== "" ? <p className={styles.span} key={x}>{x}*</p> : null
        )}
      </form>
      {width > 800 && <button
        className={!disabled ? styles.cta : styles.disabled}
        disabled={disabled && Object.values(errors).every((x) => x === "")}
        onClick={handleSubmitForm}
      >
        <img className={styles.icones16} alt="" src="/icones4.svg" />
        <div className={styles.pagamento}>
          <span className={styles.pagamentoTexto}>
            Continuar para pagamento</span>
          </div>
        <img className={styles.icones} alt="" src="/icones5.svg" />
      </button>}
    </>
  );
};

export default FormDeliveryComponent;
